import * as React from 'react';
import styled from 'styled-components';

import { PublicCleanFooter } from '@/components/Footer';

const PublicCleanLayoutWrap = styled.div`
  .public__clean__layout__wrap {
    display: grid;
    grid-template-columns: 3fr 0fr;
    height: 100%;
    overflow-y: auto;
  }
  .public__clean__layout__container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .public__clean__layout__content {
    display: flex;
    height: 100%;
  }
`;

type PublicCleanLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

export const PublicCleanLayout = (props: any) => {
  const { children }: PublicCleanLayoutProps = props;

  return (
    <PublicCleanLayoutWrap>
      <div className="h-screen">
        <div className="public__clean__layout__wrap">
          <div className="public__clean__layout__container">
            <div className="public__clean__layout__content">
              <div className="flex flex-col w-0 flex-1">
                <main className="flex-1 relative focus:outline-none z-[1]">{children}</main>
                <PublicCleanFooter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicCleanLayoutWrap>
  );
};
